import { motion } from "framer-motion";
import heroTowers from "../../assets/images/photos/hero-towers.jpg";
import { EASE_OUT } from "../motion";

/**
 * Hero paneli: ürün değil, duruş. Aşağıdan yukarı bakan gökdelenler (Anthony
 * Delanoix, Unsplash) ve yavaş, sürekli bir yaklaşma hareketi.
 */
const HeroImage = () => (
    <motion.div
        initial={{ clipPath: "inset(10% 0 0 0)", opacity: 0 }}
        animate={{ clipPath: "inset(0 0 0 0)", opacity: 1 }}
        transition={{ duration: 1.4, delay: 0.5, ease: EASE_OUT }}
        className="relative aspect-[4/5] w-full overflow-hidden bg-ink-900 md:aspect-[1290/726]"
    >
        <motion.img
            src={heroTowers}
            alt="Aşağıdan yukarı bakılan gökdelenler"
            className="absolute inset-0 h-full w-full object-cover"
            style={{ objectPosition: "50% 50%" }}
            initial={{ scale: 1.04 }}
            animate={{ scale: 1.12 }}
            transition={{ duration: 28, ease: "linear" }}
        />
        <div className="pointer-events-none absolute inset-0 bg-[linear-gradient(180deg,rgba(6,7,10,0)_60%,rgba(6,7,10,0.35)_100%)]" />
        <div className="absolute bottom-6 left-6 flex items-center gap-3 text-white md:bottom-8 md:left-8">
            <span className="h-2 w-2 rounded-full bg-white" />
            <span className="t-small font-medium">Ankara · uzaktan, dünyanın her yerine</span>
        </div>
    </motion.div>
);

export default HeroImage;
